import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=1f2f0666&lang=less"

const __exports__ = script;

export default __exports__